export default __webpack_public_path__ + "static/media/rocket_anim_64.94d70266.png";